import {
  css,
  html,
  LitElement,
  PropertyValues,
} from 'lit';
import { customElement, query } from 'lit/decorators';
import { AcetateGeometry, Bounds, IPoint, Map, MapLayer, MapLayerAcetate, MapLayerBalloon, MapLayerMeasure, MapLayerKMS, MapLayerTilesKMS, MapUtils } from '../../../shared/map/kelydra-map';
import { ICartoServiceInfo, SilverPrgApplication } from '../../sp-application';
import { MapLayerTilesDynamic, TilesProviderBing, TilesProviderOSM } from '../../../shared/map/kelydra-map-tiles';
import { IDocElement } from '../../services';
import { mapStyles } from './sb-carto-styles';
import { commonStyles } from '../../../core/styles';

@customElement('silver-map')
export class SilverMap extends LitElement {

  public static SCALE_FACTOR = 3.28 * 1024;

  static styles = [
    mapStyles,
    commonStyles,
    css`


    #map-container {
      position:relative;
      width:100%;
      height:100%;
      overflow:hidden;
    }

    #map {
      position:absolute;
      inset:0px;
    }

    .map-tools {
      position: absolute;
      top:100px;
      left:15px;
    }

    .map-tool {
      width:32px;
      height:32px;
      background:white;
      border:1px solid lightgray;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      margin-bottom: 8px;
      cursor:pointer;
    }

    .map-tool:hover {
      background:#f0f0f0;
    }

    .map-tool img {
      width:26px;
    }



  `
  ];


  protected cartoUrl:string;

  protected crs:string;

  public map:Map;
  
  protected mapExtents:Bounds;
  layerMain:MapLayerKMS;
  protected layerTiles:MapLayerTilesDynamic;
  protected layerAcetate:MapLayerAcetate;
  protected layerMeasure:MapLayerMeasure;
  protected layerBalloon:MapLayerBalloon;

  @query('#edMapScale')
  edMapScale:HTMLInputElement;



  constructor() {
    super();
  }

  get scale():string {
    return Math.round(SilverMap.SCALE_FACTOR / this.map.scale).toString();
  }


  get acetates():AcetateGeometry<string>[] {
    return this.layerAcetate.acetates;
  }


  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
  }

  public initMap(cartoUrl:string, servicesInfo:ICartoServiceInfo[], crs:string, options:{background?:string}) {
    this.cartoUrl = cartoUrl;
    this.crs = crs;

    let background = options?.background || '#ffffff';


    this.map = new Map({
      container:this.shadowRoot.querySelector("#map"),
      crs:this.crs,
      background:background,
      mobile:false
    });

    servicesInfo.forEach(serviceInfo => {
      let layer:MapLayer;
      switch (serviceInfo.type) {
        case 'public-tiles':
          if (!this.layerTiles) {
            this.layerTiles = layer = new MapLayerTilesDynamic({id:'public-tiles', caption:'Pubblica'});
          }
          if (serviceInfo.name == 'bing') {
            this.layerTiles.addTilesProvider(new TilesProviderBing());
          } else if (serviceInfo.name == 'osm') {
            this.layerTiles.addTilesProvider(new TilesProviderOSM());
          }
          break;
        case 'tiles':
          layer = new MapLayerTilesKMS({id:serviceInfo.name, caption:serviceInfo.caption, url:this.cartoUrl + serviceInfo.url});
          if (this.layerTiles) {
            this.layerTiles.visible = false;
          }
          break;
        case 'KMS':
          layer = new MapLayerKMS({id:serviceInfo.name, caption:serviceInfo.caption, url:this.cartoUrl + serviceInfo.url});
          if (layer.id == 'main') {
            this.layerMain = layer as MapLayerKMS;
            layer.infoReady().then((info) => {
              console.log("layer ready");
              this.mapExtents = Bounds.toBounds(info.bounds);
              this.map.setMapBounds(this.mapExtents, true);
              let mapReadyEvent = new CustomEvent<void>('mapReady');
              this.dispatchEvent(mapReadyEvent);
              
            });

          }
          break;
      }

      if (layer) {
        this.map.addLayer(layer);
        layer.setOpacity(serviceInfo.alpha);
        this.map.setOnClick((point:IPoint, event:MouseEvent|TouchEvent) => {
          this.onMapClick(point, event);
        })
      }

    });

    this.layerAcetate = this.map.addLayer(new MapLayerAcetate({}));
    this.layerMeasure = this.map.addLayer(new MapLayerMeasure({}));
    this.layerBalloon = this.map.addLayer(new MapLayerBalloon({width:280, height:200}));

    this.map.setOnUpdate(() => {
      this.edMapScale.value = this.scale;
    });

  }

  public async updateMap() {
    //this.mainLayer.queryStringVisibleLayers = Object.keys(this.application.cartoMap.layerVisible).join(",");
    //this.mainLayer.queryStringHiddenLayers = Object.keys(this.application.cartoMap.layerHidden).join(",");
    this.refreshMap();
  }

  public async refreshMap() {
    this.map.updateLayers();
  }

  public doZoom(scale:number) {
    if (scale == -1) {
      this.map.setMapBounds(this.mapExtents, true);
    }  else if (scale > 0) {
      this.map.setMapBounds(this.map.mapBounds.scale(scale), true);
    }
  }

  doScaleChange() {
    let scale:number = SilverMap.SCALE_FACTOR / parseFloat(this.edMapScale.value);
    let x = this.map.mapBounds.centerX;
    let y = this.map.mapBounds.centerY;
    var w = this.map.width;
    var h = this.map.height;
    var bounds = new Bounds(x - w/2, y - h/2, x + w/2, y + h/2);
    this.map.setMapBounds(bounds.scale(1/scale));
  }


  public acetateAddWkt(wkt:string, data:string, zoomTo:boolean = false) {
    var geometry = MapUtils.geometryFromWkt(wkt);
    let acetate = this.layerAcetate.addAcetate(new AcetateGeometry(geometry))
    acetate.data = data;
    if (zoomTo) {
      let bounds = acetate.geometry.bounds.offset(100,100);
      this.map.setMapBounds(bounds);
    }
  }

  public acetateClearAll() {
    this.layerAcetate.clearAll();
  }


  protected onMapClick(point:IPoint, event:MouseEvent|TouchEvent):void {
    if (this.layerMeasure._geometry) {
      return;
    }
    this.doIdentify(point);
  }

  async doIdentify(point:IPoint, centerMap:boolean = false) {
    if (centerMap) {
      let bounds = Bounds.toBounds(this.map.mapBounds).center(point.x, point.y);
      this.map.setMapBounds(bounds);
    }


    var queryString:string = "x="+point.x+"&y="+point.y+"&r="+(this.map.pixelSize * 5);

    //Prendo i layer attivi
    var queryStringVisibility = this.layerMain.getQueryStringVisibility();
    if (queryStringVisibility) {
      queryString += "&" + queryStringVisibility;
    }

    
    let data:IDocElement = await SilverPrgApplication.instance.remoteCall(this.layerMain.url +   '/map/identify?'+queryString);

    var content = "<div class='layers'>";

    //Coordinate
    content += "<table>";
    if (data.lat != 0 || data.lng != 0) {
        content += "<tr><td colspan='3'><b>Coordinate</b><br>" + data.x + ", "+ data.y+"<br>"+data.lat+", "+data.lng+"</td></tr>";
    } else {
        content += "<tr><td colspan='3'><b>Coordinate</b><br>" + data.x + ", "+ data.y+"</td></tr>";
    }


    let documentIds:string[] = [];

    for (var i = 0; i < (data.children || []) .length; i++) {
        var layer:IDocElement = data.children[i];
        content += "<tr>";
        content += "<td class='caption'>"+layer.content+"</td>";
        content += "<td class='symbol'><img src='"+layer.iconUrl+"'></td>";
        if (layer.entityId != null && false) {
            content += "<td class='selection'><button type='button' data-entityId='"+layer.entityId+"'><k-icon name='pushpin' rotate='45'></k-i></button></td>";
        } else {
            content += "<td class='selection'>&nbsp;</td>";
        }
        content += "</tr>";

        //Eventuali documenti
        if (layer.documents) {
          content += "<tr>";
          content += "<td colspan=3 >";
          content += "<div class='details'>";
          for (let document of layer.documents) {
            content += "<div class='detail'>"
            content += "<div class='fill'>" + document.DC_TITLE + "</div>"
            content += "<div class='selection'><button type='button' data-entityId='"+document.entityId+"' data-viewer='documentTreeViewer'><img src='resources/svg/book.svg'></button></div>"
            content += "</div>"

            if (documentIds.indexOf(document.entityId) == -1) {
              documentIds.push(document.entityId);
            }
          }
          content += "</div>";
          content += "</td>";
          content += "<tr>";
        }
        
    }

    if (documentIds.length) {
        content += "<tr><td colspan='3' class='text-center'><button class='docsView' type='button'>Norme selezionate <img src='resources/svg/book.svg'></button></td></tr>";
    }

    //StreetView
    if (data.lat != 0 || data.lng != 0) {
        content += "<tr><td colspan='3' class='text-center'><button class='streetView' type='button'>StreetView <img src='resources/svg/street-view-doll.svg'></button></td></tr>";
    }

    content += "</table>";
    content += "</div>";
    var contentNode:HTMLElement = this.layerBalloon.showPopup(point,content);
    var self = this;
    let addClickHandler = (element:HTMLElement) => {
      element.onclick = async () => {
        var entityId =  element.getAttribute('data-entityId');
        var viewerName =  element.getAttribute('data-viewer') || "Entity";
        if (viewerName == "documentTreeViewer") {
          SilverPrgApplication.instance.doDocumentTree(entityId.substring(0, entityId.indexOf(':')));
        }
      }
    }
    contentNode.querySelectorAll('.selection button').forEach(element => {
      addClickHandler(element as HTMLElement);
    });

    (contentNode.querySelector('.docsView') as HTMLElement).onclick = () => {
      SilverPrgApplication.instance.doDocumentTree(documentIds.map(entityId => entityId.substring(0, entityId.indexOf(':'))));
    }



    (contentNode.querySelector('.streetView') as HTMLElement).onclick = () => {
        let streetViewUrl = "https://maps.google.com/?cbll="+data.lat+","+data.lng+"&layer=c";
        window.open(streetViewUrl,'streetview');
    }
  }

  public doStartIdentify() {
    this.layerMeasure.cancelMeasure();
  }
  
  public doStartMeasure(callback:(distance:number, perimeter:number, area:number) => void) {
    let updateMeasure = (wkt:string) => {
      const geometry = this.layerMeasure._geometry
      let area2 = 0;
      let seg = 0;
      let length = 0;
      const n = geometry.points.length;
  
      if (n > 1) {
        for (var i = 0; i < n; i++) {
          var j = (i + 1) % n;
          var pi = geometry.points[i];
          var pj = geometry.points[j];
          area2 += pi.x * pj.y;
          area2 -= pi.y * pj.x;

          seg = Math.sqrt((pi.x - pj.x)*(pi.x - pj.x) + (pi.y - pj.y)*(pi.y - pj.y));
          length += seg;
      }
      length -= seg;
    }
  
      const area = Math.abs(area2 / 2);
      const distance = length;
      const perimeter = length + seg;

      callback(distance, perimeter, area);
    };
    let completeMeasure = (wkt:string) => {
      updateMeasure(wkt);
    }
    this.layerMeasure.startMeasure(completeMeasure, updateMeasure);
    updateMeasure(null);
  }




  render() {
    return html`
      <div id="map-container">
        <div id="map"></div>
        <div class="map-tools">
          <div class="map-tool" @click=${() => this.doZoom(-1)}><img src="resources/svg/zoom-all.svg"></div>
          <div class="map-tool" @click=${() => this.doZoom(0.7)}><img src="resources/svg/zoom-in.svg"></div>
          <div class="map-tool" @click=${() => this.doZoom(1.2)}><img src="resources/svg/zoom-out.svg"></div>
        </div>
        <div class="map-scale">
          Scala 1:<input id="edMapScale"></input><button type="button" @click=${this.doScaleChange}>Cambia</button>
        </div>

      </div> 
    `
  }
}


